<template>

    <div>

        <toolbar :title="'Impressum'"></toolbar>

          <v-divider></v-divider>

            <v-responsive>
                <v-card-text >

                    <v-container class="pa-0">

                        <template>
                          <v-progress-linear v-if="timeToWait === true && adresse.length === 0" color="red" :indeterminate="true"></v-progress-linear>
                        </template>

                        <v-layout row wrap v-if="thereIsAnError">

                            <v-flex>
                                Die Daten konnten nicht abgerufen werden. Fehler 404.
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap v-if="adresse">

                            <v-flex xs12>
                                <div>
                                    <a href="https://www.software-schiek.de" target="_blank" style="background-color: #fff; display: inline-block; padding: 3px 3px 0 3px; height: 46px"><img style="width: 100%; height: auto;" src="https://www.software-schiek.de/img/logo.png"></a>
                                </div>
                            </v-flex>


                            <v-flex xs12>
                                <div v-html="adresse"></div>
                            </v-flex>


                            <v-flex xs12>

                                <div v-html="telefon"></div>

                                <div v-html="email"></div>

                                <div v-html="website"></div>

                                <v-divider v-if="zusatzinfo.length > 0"></v-divider>

                                <div class="mt-3" v-html="zusatzinfo"></div>

                            </v-flex>
                        </v-layout>
                    </v-container>

                </v-card-text>

            </v-responsive>
    </div>

</template>

<script>
    export default {
        name: 'impressum',
        props: {

        },
        computed: {
        },
        watch: {

        },

        data: () => ({
            adresse: "",
            telefon: "",
            email: "",
            website: "",
            zusatzinfo: "",
            timeToWait: false,
            thereIsAnError: false
        }),

        methods: {

        },

        beforeCreate() {

            const vu = this;
            let myTimeout = window.setTimeout(function(){
                vu.timeToWait = true;
            }, 1500);

            this.axios.get("https://apiv1.software-schiek.de/impressum").then( (response) => {
                vu.timeToWait = false;
                window.clearTimeout(myTimeout);
                if ( typeof response.data.adresse !== "undefined" ) {
                    this.adresse = response.data.adresse;
                }
                else {
                    if ( typeof response.data.message !== "undefined" ) {
                        this.adresse = response.data.message;
                    }
                }
                if ( typeof response.data.telefon !== "undefined" ) {
                    this.telefon = response.data.telefon;
                }
                if ( typeof response.data.email !== "undefined" ) {
                    this.email = response.data.email;
                }
                if ( typeof response.data.website !== "undefined" ) {
                    this.website = response.data.website;
                }
                if ( typeof response.data.zusatzinfos !== "undefined" ) {
                    this.zusatzinfo = response.data.zusatzinfos;
                }

            }).catch(() => {
                vu.thereIsAnError = true;
                vu.timeToWait = false;
                window.clearTimeout(myTimeout);
            })

        }
    }
</script>

<style scoped>

</style>
